import { BaseModel } from "sjs-base-model";

// LocationgetModel
export default class LocationgetModel extends BaseModel {
  // response getting from the api mentioned end point
  influencer_location_data = {};
  constructor(data1) {
    super();

    this.update(data1);
  }
}
